/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketplace_Seo_Galicia_Guide_Rias_P2Inputs */

const es_marketplace_seo_galicia_guide_rias_p2 = /** @type {(inputs: Marketplace_Seo_Galicia_Guide_Rias_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puedes alquilar con o sin patrón según tu titulación, o reservar una experiencia guiada para descubrir los fondos y pueblos marinero desde el mar.`)
};

const gl_marketplace_seo_galicia_guide_rias_p2 = /** @type {(inputs: Marketplace_Seo_Galicia_Guide_Rias_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podes aluguer con ou sen patrón segundo a túa titulación, ou reservar unha experiencia guiada para descubrir os fondos e pueblos mariñeiros dende o mar.`)
};

const en_marketplace_seo_galicia_guide_rias_p2 = /** @type {(inputs: Marketplace_Seo_Galicia_Guide_Rias_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rent with or without skipper depending on your licence, or book a guided experience to discover the coast from the sea.`)
};

/**
* | output |
* | --- |
* | "Rent with or without skipper depending on your licence, or book a guided experience to discover the coast from the sea." |
*
* @param {Marketplace_Seo_Galicia_Guide_Rias_P2Inputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const marketplace_seo_galicia_guide_rias_p2 = /** @type {((inputs?: Marketplace_Seo_Galicia_Guide_Rias_P2Inputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketplace_Seo_Galicia_Guide_Rias_P2Inputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_marketplace_seo_galicia_guide_rias_p2(inputs)
	if (locale === "en") return en_marketplace_seo_galicia_guide_rias_p2(inputs)
	return es_marketplace_seo_galicia_guide_rias_p2(inputs)
});